/*
 * NewTreatmentUserStep Messages
 *
 * This contains all the text for the NewTreatmentUserStep container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.NewTreatmentUserStep";

export default defineMessages({
  patientAndTreatment: {
    id: `${scope}.patientAndTreatment`,
    defaultMessage: "Patient & Treatment",
  },
  patientId: {
    id: `${scope}.patientId`,
    defaultMessage: "Patient ID.",
  },
  searchPatient: {
    id: `${scope}.searchPatient`,
    defaultMessage: "Search patient",
  },
  selectInsurer: {
    id: `${scope}.selectInsurer`,
    defaultMessage: "Select insurer",
  },
  insuranceNumber: {
    id: `${scope}.insuranceNumber`,
    defaultMessage: "Insurance number.",
  },
  internalRef: {
    id: `${scope}.internalRef`,
    defaultMessage: "Internal ref.",
  },
  addPatient: {
    id: `${scope}.addPatient`,
    defaultMessage: "Add patient",
  },
  patient: {
    id: `${scope}.patient`,
    defaultMessage: "Patient",
  },
  changePatient: {
    id: `${scope}.changePatient`,
    defaultMessage: "Change patient",
  },
  selectDentist: {
    id: `${scope}.selectDentist`,
    defaultMessage: "Select dentist",
  },

  errorMsgPatientName: {
    id: `${scope}.errorMsgPatientName`,
    defaultMessage: "Minimum 2 characters.",
  },
});
